﻿import type {AppConfig} from "../types/app-config.type";

let config: AppConfig;

export async function loadAppConfig(): Promise<AppConfig> {
    const response = await fetch('/config.json', {
        cache: 'no-store'
    });

    if (!response.ok) {
        throw new Error(`Failed to load app config: ${response.status}`);
    }

    config = await response.json();
    return config;
}

export function getAppConfig(): AppConfig {
    if (!config) {
        throw new Error('App config has not been loaded yet.');
    }

    return config;
}